import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from 'react-router-dom'
import { visualizar } from '../../../../util/AcessoApi'

const parseValorFormatado = (str) => {
    const s = (str || '').toString().replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')
    return parseFloat(s) || 0
}

const VisualizacaoLoteLancamento = props => {
    let { id } = useParams()
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/financeiro/loteLancamento', id, obj => {
            if (!obj || !obj.id) {
                setDados({ titulo: 'Visualização Lote de Lançamentos' })
                return
            }

            const totalLancamentos = (obj.lancamentos || [])
                .reduce((acc, x) => acc + parseValorFormatado(x.valor_formatado), 0)
                .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            setDados({
                id,
                modulo: props.modulo,
                titulo: 'Visualização Lote de Lançamentos',
                grupos: [
                    {
                        titulo: 'Dados Gerais',
                        colunas: [
                            { titulo: 'Código', descricao: obj?.id, tamanho: 'col-lg-3' },
                            { titulo: 'Código do Lote', descricao: obj?.codigo, tamanho: 'col-lg-3' },
                            { titulo: 'Data Registro', descricao: obj?.data_registro, tamanho: 'col-lg-3' },
                            { titulo: 'Qtd. Lançamentos', descricao: obj?.qtd_lancamentos ?? (obj?.lancamentos || []).length, tamanho: 'col-lg-3' },
                            { titulo: 'Valor Total', descricao: totalLancamentos, tamanho: 'col-lg-3' },
                            { titulo: 'Estabelecimento(s)', descricao: (obj?.estabelecimentos || []).map(e => e.label).join(', ') || obj?.estabelecimento || '-', tamanho: 'col-lg-9' }
                        ]
                    },
                    {
                        tipoGrupo: 'tabela',
                        titulo: 'Lançamentos do Lote',
                        visivel: (obj.lancamentos || []).length > 0,
                        thead:
                            <tr>
                                <td className='coluna-1' colspan='1'>Cód.</td>
                                <td className='coluna-1' colspan='1'>Data Prevista</td>
                                <td className='coluna-2' colspan='2'>Atend. - Paciente</td>
                                <td className='coluna-2' colspan='2'>Cliente</td>
                                <td className='coluna-1' colspan='1' style={{ textAlign: 'right' }}>Valor</td>
                            </tr>,
                        tbody: (obj.lancamentos || []).length === 0 ? (
                            <tr><td colspan='9'>Sem Registro!</td></tr>
                        ) : obj.lancamentos.map(x => (
                            <tr key={x.id}>
                                <td colspan='1'>{x.id}</td>
                                <td colspan='1'>{x.data_prevista}</td>
                                <td colspan='2'>{(x.atendimento_id || '-') + ' - ' + (x.nome_beneficiario || '-')}</td>
                                <td colspan='2'>{x.cliente || '-'}</td>
                                <td colspan='1' style={{ textAlign: 'right' }}>{x.valor_formatado}</td>
                            </tr>
                        ))
                    }
                ]
            })
        })
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

export default VisualizacaoLoteLancamento
